import { ApplicationCustomer } from "@ploy-lib/types";
import {
	FieldType,
	IFormTableSchema,
	ColumnMetadata,
	TableMetadata
} from "./types";

export class ApplicationCustomersSchema
	implements IFormTableSchema<ApplicationCustomer>
{
	tableMetadata: TableMetadata<Partial<ApplicationCustomer>> = {
		dployTesterContext: "ApplicaitonCustomers",
		isReadOnlyRow: (rowData: any, cells: any) =>
			rowData?.engagementCustomerId &&
			rowData.engagementCustomerId !== rowData.customerId
	};

	columnMetadata: Partial<
		Record<keyof ApplicationCustomer, ColumnMetadata<ApplicationCustomer>>
	> = {
		phoneMobile: {
			fieldType: FieldType.Text,
			isRequired: true,
			// Disable and hide value if mainCustomer
			isEditableFunctions: {
				EditableIfNotMainCustomer: form => {
					const isMainCustomer = form.values["isMainCustomer"] as boolean;
					return !isMainCustomer;
				}
			},
			displayValue: (value: any, rowData) => {
				return rowData.isMainCustomer ? "" : value;
			}
		},
		email: {
			fieldType: FieldType.Text,
			isRequired: true,
			// Disable and hide value if mainCustomer
			isEditableFunctions: {
				EditableIfNotMainCustomer: form => {
					const isMainCustomer = form.values["isMainCustomer"] as boolean;
					return !isMainCustomer;
				}
			},
			displayValue: (value: any, rowData) => {
				return rowData.isMainCustomer ? "" : value;
			}
		},
		customerNumber: {
			fieldType: FieldType.Text,
			isRequired: true
		},
		customerRole: {
			fieldType: FieldType.Select,
			isRequired: true
		},
		isResident: {
			fieldType: FieldType.Checkbox,
			hide: (value, rowData, cells, isPlaceholder, firstInGroup) => {
				const role = rowData["customerRole"] as Number | undefined;
				return role !== 12;
			},
			isEditableFunctions: {
				EditableIfHouseOwner: (form, row) => {
					const role = row.find(c => c.column.id === "customerRole")?.value as
						| Number
						| undefined;
					return role === 12;
				}
			}
		}
	};
}
